// Chakra imports
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  Input,
  Link,
  Switch,
  Text,
  useColorModeValue,
  LightMode,
  useToast,
} from "@chakra-ui/react";
// Assets
import BgSignUp from "assets/img/BgSignUp.png";
import React, { useState, useEffect } from "react";
import { InputMask } from "@react-input/mask";
import { FaApple, FaFacebook, FaGoogle, FaWindows } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { Name } from "ajv";
import { setTokenSourceMapRange } from "typescript";

import { Link as RouterLink } from "react-router-dom";

// import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

const notify_error = () => {
  toast.error("Complete the form");
};

const notify_error_email = () => {};

function Direct() {
  const bgForm = useColorModeValue("white", "navy.800");
  const titleColor = useColorModeValue("gray.700", "blue.500");
  const textColor = useColorModeValue("gray.700", "white");
  const colorIcons = useColorModeValue("gray.700", "white");
  const bgIcons = useColorModeValue("trasnparent", "navy.700");
  const bgIconsHover = useColorModeValue("gray.50", "whiteAlpha.100");

  const toast = useToast();

  const { member } = useParams();

  const [idtomado, setIdtomado] = useState(member);

  const [referido, setReferido] = useState([]);

  const [errorname, setErrorname] = useState("skyblue");
  const [errortelefono, setErrortelefono] = useState("skyblue");
  const [errorpass, setErrorpass] = useState("skyblue");
  const [erroremail, setErroremail] = useState("skyblue");

  const [name, setName] = useState("");
  const [telefono, setTelefono] = useState("");
  const [pass, setPass] = useState("");
  const [email, setEmail] = useState("");

  const [idvisita, setIdvisita] = useState(1);

  const [statusboton, setStatusboton] = useState(true);

  // const [location, setLocation] = useState({
  //   country: "United States",
  //   flagUrl: "https://flagcdn.com/w320/us.png",
  //   region: "Florida",
  // });

  const [location, setLocation] = useState({
    country: "",
    flagUrl: "",
    region: "",
  });

  const registrando = (
    <>
      <span className="loader"></span> &nbsp;&nbsp;&nbsp; Please wait...
    </>
  );

  const signup = <>SING UP</>;

  const verificarreferido = (id) => {
    const data = {
      id: id,
    };
    fetch(`${process.env.REACT_APP_API}/verificarreferido`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.id) {
          setReferido(result);
          setIdtomado(result.id);
          console.log(result);
        } else {
          setIdtomado(1);
          setReferido([]);
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveregister = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let type_error = "";

    if (!name) {
      setErrorname("red");
      type_error = "vacio";
    }
    if (!email) {
      setErroremail("red");
      type_error = "vacio";
    } else if (!emailRegex.test(email)) {
      // Email no es válido según el patrón
      setErroremail("red");
      type_error = "email";
    }

    if (!telefono) {
      setErrortelefono("red");
      type_error = "vacio";
    }
    if (!pass) {
      setErrorpass("red");
      type_error = "vacio";
    }

    if (type_error === "vacio") {
      toast({
        title: "Empty Fields",
        description: "Complete the Form",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setStatusboton(true);
      return;
    }

    if (type_error === "email") {
      toast({
        title: "Email Invalid",
        description: "Check your email",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setStatusboton(true);
      return;
    }

    const data = {
      idreferencia: idtomado,
      nombres: name,
      telefono: telefono,
      password: pass,
      email: email,
      idvisita: idvisita,
    };
    fetch(`${process.env.REACT_APP_API}/registerwill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          if (result.message == "ya existe") {
            console.log(result);
            setTimeout(() => {
              toast({
                title: "Email Usado",
                description: "Intente con otro Correo Electronico",
                status: "error",
                duration: 5000,
                isClosable: true,
              });
              setErroremail("red");
              setStatusboton(true);
            }, 1000);
          }
          if (result.message == "registro exitoso") {
            console.log(result);
            setTimeout(() => {
              toast({
                title: "Successful registration",
                description: "Redirect to Dashboard",
                status: "success",
                duration: 5000,
                isClosable: true,
              });

              setTimeout(() => {
                logeo(data.email, data.password);
              }, 2000);
            }, 1000);
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const guardarvisita = () => {
    const data = {
      desde: "Direct Link",
      pais: location.country,
      estado: location.region,
      imagen: location.flagUrl,
      idu: idtomado,
    };
    fetch(`${process.env.REACT_APP_API}/visitaswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          console.log(result);
          setIdvisita(parseInt(result.message));
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const logeo = (user, pass) => {
    const data = {
      username: user,
      password: pass,
    };
    fetch(`${process.env.REACT_APP_API}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.token) {
            localStorage.setItem("token_royal", result.token);
            window.location.href = "/#/admin/dashboard";
            window.location.reload();
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCountryName = async (countryCode) => {
    try {
      const response = await axios.get(
        `https://restcountries.com/v3.1/alpha/${countryCode}`
      );
      return response.data[0].name.common;
    } catch (error) {
      console.error("Error fetching country name:", error);
      return countryCode;
    }
  };

  useEffect(() => {}, [location]);

  useEffect(() => {
    const getLocation = async () => {
      try {
        const response = await axios.get(
          "https://ipinfo.io?token=22f2ae18bba33a"
        );
        const { country, region } = response.data;
        const flagUrl = `https://flagcdn.com/w320/${country.toLowerCase()}.png`;
        const countryName = await getCountryName(country);
        setLocation({ country: countryName, flagUrl, region });
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    getLocation();
  }, []);

  useEffect(() => {
    if (member) {
      verificarreferido(member);
    }
  }, []);

  useEffect(() => {
    if (!statusboton) {
      saveregister();
    }
    console.log(statusboton);
  }, [statusboton]);

  useEffect(() => {
    console.log(referido.length);
  }, [referido]);

  useEffect(() => {
    if (idtomado !== 0) {
      if (
        location.country !== "" &&
        location.region !== "" &&
        location.flagUrl !== ""
      ) {
        console.log(location);
        guardarvisita();
      }
    }
  }, [idtomado, location]);

  useEffect(() => {
    if (name) {
      setErrorname("skyblue");
    }
  }, [name]);

  useEffect(() => {
    if (telefono) {
      setErrortelefono("skyblue");
    }
  }, [telefono]);

  useEffect(() => {
    if (email) {
      setErroremail("skyblue");
    }
  }, [email]);

  useEffect(() => {
    if (pass) {
      setErrorpass("skyblue");
    }
  }, [pass]);

  return (
    <Flex
      direction="column"
      alignSelf="center"
      justifySelf="center"
      overflow="hidden"
    >
      <Box
        position="absolute"
        minH={{ base: "70vh", md: "50vh" }}
        maxH={{ base: "70vh", md: "50vh" }}
        w={{ md: "calc(100vw - 50px)" }}
        maxW={{ md: "calc(100vw - 50px)" }}
        left="0"
        right="0"
        bgRepeat="no-repeat"
        overflow="hidden"
        zIndex="-1"
        top="0"
        bgImage={BgSignUp}
        bgSize="cover"
        mx={{ md: "auto" }}
        mt={{ md: "14px" }}
        borderRadius={{ base: "0px", md: "20px" }}
      >
        <Box w="100vw" h="100vh" bg="#003366" opacity="0.7"></Box>
      </Box>
      <Flex
        direction="column"
        textAlign="center"
        justifyContent="center"
        align="center"
        mt="125px"
        mb="30px"
      >
        <Text fontSize="4xl" color="white" fontWeight="bold">
          Welcome!
        </Text>
        <Text
          fontSize="md"
          color="white"
          fontWeight="normal"
          mt="10px"
          mb="26px"
          w={{ base: "90%", sm: "60%", lg: "40%", xl: "333px" }}
        >
          Earn 30$ for each referral who purchases your insurance policy and
          becomes a part of this team,{" "}
          {referido.nombres ? <>{referido.nombres} </> : <>Royal Insurance </>}
          invites you to get good rewards
        </Text>
      </Flex>
      <Flex alignItems="center" justifyContent="center" mb="60px" mt="20px">
        <Flex
          direction="column"
          w="445px"
          background="transparent"
          borderRadius="15px"
          p="40px"
          mx={{ base: "100px" }}
          bg={bgForm}
          boxShadow={useColorModeValue(
            "0px 5px 14px rgba(0, 0, 0, 0.05)",
            "unset"
          )}
        >
          <Text
            fontSize="xl"
            color={textColor}
            fontWeight="bold"
            textAlign="center"
            mb="22px"
          >
            Register With
          </Text>

          <FormControl>
            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
              Name
            </FormLabel>
            <Input
              variant="auth"
              fontSize="sm"
              ms="4px"
              type="text"
              placeholder="Your full name"
              mb="24px"
              size="lg"
              id="name-royal"
              borderColor={errorname}
              onChange={(e) => setName(e.target.value)}
            />

            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
              Email
            </FormLabel>
            <Input
              variant="auth"
              fontSize="sm"
              ms="4px"
              type="text"
              placeholder="jhon@example.com"
              mb="24px"
              size="lg"
              id="email-royal"
              borderColor={erroremail}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
              Telefono
            </FormLabel>

            <Input
              mask="+0 (999) 999-9999"
              replacement={{ 0: /\d/, 9: /\d/ }}
              placeholder="+1 (234) 567-8901"
              type="text"
              variant="auth"
              fontSize="sm"
              ms="4px"
              mb="24px"
              size="lg"
              id="phone-royal"
              borderColor={errortelefono}
              onChange={(e) => setTelefono(e.target.value)}
            />

            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
              Password
            </FormLabel>
            <Input
              variant="auth"
              fontSize="sm"
              ms="4px"
              type="password"
              placeholder="Your password"
              mb="24px"
              size="lg"
              id="password-royal"
              borderColor={errorpass}
              onChange={(e) => setPass(e.target.value)}
            />
            <FormControl display="flex" alignItems="center" mb="24px">
              <Switch id="remember-login" colorScheme="yellow" me="10px" />
              <FormLabel htmlFor="remember-login" mb="0" fontWeight="normal">
                Remember me
              </FormLabel>
            </FormControl>
            <Button
              fontSize="14px"
              variant="dark"
              fontWeight="bold"
              w="100%"
              h="45"
              mb="24px"
              onClick={() => {
                setStatusboton(false);
              }}
            >
              {statusboton ? signup : registrando}
            </Button>
          </FormControl>
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            maxW="100%"
            mt="0px"
          >
            <Text color={textColor} fontWeight="medium">
              Already have an account?
              <Link
                color={titleColor}
                as={RouterLink}
                ms="5px"
                to="/auth/signin"
                fontWeight="bold"
              >
                Login
              </Link>
            </Text>
          </Flex>
        </Flex>
      </Flex>
      {/* <Toaster /> */}
    </Flex>
  );
}

export default Direct;
